import {v4 as uuid } from "uuid";

export const getBase64 = (file) => {
  const reader = new FileReader();
  return new Promise((resolve) => {
    reader.addEventListener("load", () => resolve(String(reader.result)));
    reader.readAsDataURL(file);
  });
};

export const getListFiles = (files, dataURLKey) => {
  const promiseFiles = [];
  for (let i = 0; i < files.length; i += 1) {
    promiseFiles.push(getBase64(files[i]));
  }
  return Promise.all(promiseFiles).then((fileListBase64) => {
    const fileList = fileListBase64.map((base64, index) => ({
      [dataURLKey]: base64,
      file: files[index],
    }));
    return fileList;
  });
};
function chunkBase64String(base64String) {
  const chunks = [];
  const chunkSize = 90 * 1024 * 1024;
  for (let i = 0; i < base64String.length; i += chunkSize) {
    const chunk = base64String.slice(i, i + chunkSize);
    chunks.push(chunk);
  }
  return chunks;
};

export function toVideoData(video) {
   
    const tempId = uuid(); 
    const videoName = video.file.name;
    const videoType = video.file.type;
    const video64 = chunkBase64String(video.data_url.split(";")[1].split(",")[1]);
    return {
        tempId,
        videob64: video64,
        videoName: videoName,
        videoType: videoType,
        video: video,
    };
}
